import { render, staticRenderFns } from "./datatable-column.vue?vue&type=template&id=37a51e90&"
import script from "./datatable-column.vue?vue&type=script&lang=js&"
export * from "./datatable-column.vue?vue&type=script&lang=js&"
import style0 from "./datatable-column.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports